var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// libs
import React from 'react';
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// components
import { Button } from '@swiggy-private/dls-web-core/dist/components/Button';
import { TextButton } from '@swiggy-private/dls-web-core/dist/components/TextButton';
// stores
import useAccountStore from '@/stores/account';
//includes
import { deactivateCampaignApi } from '@/includes/api/campaign/deactivate';
// styles
import style from '../../ActionMenu.module.scss';
const DeactivateModalContent = ({ closeModal, campaignName, campaignId, }) => {
    const getCurrentAccountId = useAccountStore((state) => state.getCurrentAccountId);
    const handleDeactivate = () => __awaiter(void 0, void 0, void 0, function* () {
        closeModal();
        if (campaignId) {
            try {
                const accountId = yield getCurrentAccountId();
                yield deactivateCampaignApi({ campaignId, accountId });
                window.location.reload();
            }
            catch (e) {
                // do nothing
            }
        }
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Text, { variant: DlsFontVariants.header_H2_Black, color: DlsColorTokens.text_Highest_Emphasis, className: style.modalTitle }, "Deactivate campaign?"),
        React.createElement(Text, { variant: DlsFontVariants.header_H4_Med, color: DlsColorTokens.text_High_Emphasis, className: style.modalText },
            "Are you sure you want to deactivate your campaign",
            React.createElement(Text, { variant: DlsFontVariants.header_H4_Black, color: DlsColorTokens.text_Highest_Emphasis, className: style.modalTextInline }, ` ${campaignName}?`)),
        React.createElement(Text, { variant: DlsFontVariants.body_B1_Reg, color: DlsColorTokens.text_Med_Emphasis, className: style.modalText }, "Deactivating the campaign would disable your Ad from showing up on the Swiggy app."),
        React.createElement("div", { className: style.modalButtons },
            React.createElement(TextButton, { onClick: closeModal, className: style.modalCancelButton, buttonSize: "small", color: DlsColorTokens.primary }, "Don't Deactivate"),
            React.createElement("div", { className: style.modalPrimaryButton },
                React.createElement(Button, { variant: "primary", onClick: handleDeactivate }, "Deactivate")))));
};
export default DeactivateModalContent;
